"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _rdsIcons = require("@ruter-ds/rds-icons");

var _excluded = ["id", "onClick", "contentId", "expanded", "className", "children", "chevronColor"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  children: _propTypes.node,
  expanded: _propTypes.bool,
  id: _propTypes.string,
  contentId: _propTypes.string,
  className: _propTypes.string,

  /** Choose the color of the chevron */
  chevronColor: (0, _propTypes.oneOf)(['info', 'dark'])
};

var AccordionItemHeading = function AccordionItemHeading(_ref) {
  var id = _ref.id,
      onClick = _ref.onClick,
      contentId = _ref.contentId,
      expanded = _ref.expanded,
      className = _ref.className,
      children = _ref.children,
      chevronColor = _ref.chevronColor,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("button", _extends({
    type: "button",
    className: (0, _classnames.default)('rds-accordion-item__heading', className),
    id: id,
    onClick: onClick,
    "aria-controls": contentId,
    "aria-expanded": expanded,
    role: "heading"
  }, rest), children, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    component: /*#__PURE__*/_react.default.createElement(_rdsIcons.ChevronDownIcon, null),
    size: "small",
    className: (0, _classnames.default)('rds-accordion-item__arrow', {
      'rds-accordion-item__arrow--expanded': expanded,
      'rds-accordion-item__arrow--dark': chevronColor === 'dark'
    })
  }));
};

AccordionItemHeading.propTypes = propTypes;
var _default = AccordionItemHeading;
exports.default = _default;